import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';

import { client } from './client';

export const baseQuery = graphqlRequestBaseQuery({ client });
